import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    maxWidth: "100%",
  },
  media: {
    height: 100,
  },
});

const handleClick = (fullNewsLink) => {
  window.open(fullNewsLink);
};

export default function MediaCard({
  imageUrl,
  title,
  newsDescription,
  fullNewsLink,
}) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        {imageUrl && (
          <CardMedia
            className={classes.media}
            image={imageUrl}
            // title="Contemplative Reptile"
          />
        )}
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {newsDescription}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          size="small"
          color="secondary"
          variant="contained"
          onClick={() => handleClick(fullNewsLink)}
        >
          VIEW FULL NEWS
        </Button>
      </CardActions>
    </Card>
  );
}
